angular
    .module('annexaApp')
	.controller('AddressIdentificationReferenceTypeController',['$scope', '$rootScope', 'CommonAdminModals', 'AnnexaFormlyFactory', 'RestService', 'AnnexaModalFactory', 'Language', '$filter', 'GlobalDataFactory', 'CacheFactory', 'apiAdmin', 'DialogsFactory',
    	function($scope, $rootScope, CommonAdminModals, AnnexaFormlyFactory, RestService, AnnexaModalFactory, Language, $filter, GlobalDataFactory, CacheFactory, apiAdmin, DialogsFactory) {

			$scope.filter = [
				{ id: Language.getActiveColumn(), type: 'text', order: 0, label: 'global.literals.name'},
				{ id: 'code', type: 'text', order: 1, label: 'global.territory.list.address_identification_reference_type', callAux: true }
			];

			$scope.additionalColumns = [
				{ id: 'code', title: $filter('translate')('global.literals.code')}
			];

			$scope.newElement = function() {
				var modal = angular.copy(CommonAdminModals.addressIdentificationReferenceTypeNew);
				modal.annexaFormly.model = {};
				modal.annexaFormly.model.modal_body = {};
				modal.annexaFormly.options = {};
				
				AnnexaFormlyFactory.showModal('modalNewAddressIdentificationReferenceType', modal, $scope.saveAddressIdentificationReferenceType, false);
			}

			$scope.saveAddressIdentificationReferenceType = function (addressIdentificationReferenceType) {
				var modal = this;
				
				var model = {
					language1: addressIdentificationReferenceType.annexaFormly.model.modal_body.language1 ? addressIdentificationReferenceType.annexaFormly.model.modal_body.language1 : 'NotTranslated',
					language2: addressIdentificationReferenceType.annexaFormly.model.modal_body.language2 ? addressIdentificationReferenceType.annexaFormly.model.modal_body.language2 : 'NotTranslated',
					language3: addressIdentificationReferenceType.annexaFormly.model.modal_body.language3 ? addressIdentificationReferenceType.annexaFormly.model.modal_body.language3 : 'NotTranslated',
					code: addressIdentificationReferenceType.annexaFormly.model.modal_body.code ? addressIdentificationReferenceType.annexaFormly.model.modal_body.code : undefined
				}
				
				RestService.insert('./api/territory/address_identification_reference_type', model).then(function () {
					$rootScope.$broadcast('annexaAdminBaseReloadTable'); 
					modal.close();
				}).catch(function (error) {
					modal.alerts.push({ msg: $filter('translate')('global.errors.addressIdentificationReferenceType')});
				})
			}

			$scope.viewElement = function (id) {
				RestService.findOne('AddressIdentificationReferenceType', id).then(function(data) {
					var decodeddata = JSOG.decode(data.data);
					
					var modal = angular.copy(CommonAdminModals.addressIdentificationReferenceTypeEdit);
					modal.alerts = [];
					modal.data = decodeddata;
					modal.languageColumn = Language.getActiveColumn();
					modal.updateAddressIdentificationReferenceType = $scope.updateAddressIdentificationReferenceType;
					
					AnnexaModalFactory.showModal('modalAddressIdentificationReferenceTypeEdit', modal);
				});
			}

			$scope.updateAddressIdentificationReferenceType = function(val, prop) {
				var self = this;
				var model = angular.copy(this.data);
				
				if (_.contains(['code'], prop)) {
					model[prop] = val;
				} else {
					model = val;
				}
				
				RestService.update('./api/territory/address_identification_reference_type/' + model.id, model).then(function (data) {
					$rootScope.$broadcast('annexaAdminBaseReloadTable');
				}).catch(function (error) {
					DialogsFactory.error($filter('translate')('global.errors.addressIdentificationReferenceType'));
				});
			}
	}])